import * as React from 'react';

import {colors} from 'shells/colors/colors';

import type {ListItemStat} from './types';

import styles from './custom-fields-row-item.module.css';

export function CustomFieldsRowItemStat(props: {stat: ListItemStat}) {
    return (
        <div data-tip={props.stat.tooltipText} className={styles['icon-and-number']}>
            <div className={styles.icon}>
                <props.stat.icon size={14} color={colors.greyLt} />
            </div>
            {props.stat.count}
        </div>
    );
}
